import { useAtomValue } from 'jotai';

import { companyBetaFeaturesState } from '../states/companiesBetaFeatures';

export const useCompanyBetaFeatures = (companyId: string | undefined) => {
    const getCompanyBetaFeatures = useAtomValue(companyBetaFeaturesState);

    return getCompanyBetaFeatures(companyId);
};
